
<template>
  <div class="ezDialog">
    <v-dialog style="z-index: 1030" v-model="isShow" max-width="600"
               v-on:click:outside="clodeDialog">
      <colel-card
        :title="$t('suggestionsTable.ezTitle')"
        :icon="'mdi-alert'"
        :color="'warning'"
      >
        <template v-slot:content>
              <v-card-title>
            {{title}}
              </v-card-title>
          <v-card-text>
            <v-col cols="6">
			                <InputNumber
							 :placeholder="$t('suggestionsTable.ez')"
								    v-model="ezNumber" />


            </v-col>
          </v-card-text>
          <v-card-text>
          </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text outlined @click="clodeDialog">
                  {{ $t("deleteDialog.cancel") }}
                </v-btn>
                <v-btn
				 :disabled="ezNumber === null"
                  color="blue darken-4"
                  outlined
                  text
                  @click="ok"
                  >{{ $t("suggestionsTable.sendSuggestion") }}</v-btn
                >
              </v-card-actions>
        </template>
      </colel-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: "ezDialog",
  components: {

  },
  props: {
    isShow: Boolean,
    title: String,
  },

  data() {
    return {
      showDialog: false,
      valid: false,
      personObj: null,
      ezNumber: null
    };
  },
  watch: {
    person(newPerson) {
      this.personObj = newPerson;
    },
  },
  methods: {
    clodeDialog() {

      this.$emit("closeDialog");
    },
    ok() {
      this.$emit("ok", this.ezNumber);
      this.$emit("closeDialog");
    },
  },
};
</script>
